import React from 'react';
import { UnitZoneTableView } from '../../utils/pumpMismatchDisplay';

interface UnitZoneViewToggleProps {
  value: UnitZoneTableView;
  onChange: (view: UnitZoneTableView) => void;
  className?: string;
  id?: string;
}

const OPTIONS: { value: UnitZoneTableView; label: string }[] = [
  {
    value: 'byRevisionValue',
    label: 'Revision Value',
  },
  {
    value: 'byUnit',
    label: 'Units',
  },
];

/** Two-option view for unit/zone tables. Default is by revision value. */
const UnitZoneViewToggle: React.FC<UnitZoneViewToggleProps> = ({
  value,
  onChange,
  className = '',
  id = 'unit-zone-view',
}) => {
  return (
    <div className={`flex items-center ${className}`} dir="ltr">
      <div
        id={id}
        role="radiogroup"
        aria-label="View"
        className="flex items-center gap-0.5 rounded-lg bg-gray-100 p-1"
      >
        {OPTIONS.map((option) => {
          const selected = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => onChange(option.value)}
              className={`
                rounded-md px-3 py-1.5 text-sm whitespace-nowrap transition-colors
                ${selected
                  ? 'bg-white font-semibold text-gray-900 shadow-sm'
                  : 'font-medium text-gray-600 hover:text-gray-900'}
              `}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default UnitZoneViewToggle;
